import { IonCard, IonCardContent, IonCol, IonIcon, IonItem, IonRow } from "@ionic/react";
import React, { FC } from "react";
import {default as find_customers_icon} from "../../../AE2/static/icons/actions_row/Find Customers.svg"
import {default as success_stories_icon} from "../../../AE2/static/icons/actions_row/View Success Stories.svg"
import {default as side_arrow_icon} from "../../../AE2/static/icons/actions_row/Side Arrow.svg"
import {default as report_icon} from "../../../AE2/static/icons/actions_row/Run a Report.svg"
import './ActionsRow.css'

interface IProps {};

const ActionsRow:FC<IProps> = (props) => {
    return <IonRow className="actions-row" style={{minHeight:'100px'}}>
        <IonCol size='3' >
            <IonCard className="h-100 grey-border-2pt">
                <IonCardContent>
                    <IonIcon src={find_customers_icon} slot="start"/>                    
                    <div className="quick-actions__text ">
                        <h3 className="text-map-main font-helvetica font-bold font-13pt">Find Customers</h3>
                        <p className="text-footer-blue font-helvetica font-med font-12pt">Search and explore customers profiles</p>
                    </div>
                    <IonIcon className="arrow_icon" src={side_arrow_icon} slot="end"></IonIcon>
                </IonCardContent>                
            </IonCard>
        </IonCol>
        <IonCol size="3" > 
            <IonCard className="h-100 grey-border-2pt" routerLink="/success_stories">
                <IonCardContent>
                    <IonIcon src={success_stories_icon} slot="start"/>                    
                    <div className="quick-actions__text ">
                        <h3 className="text-map-main font-helvetica font-bold font-13pt">View Success Stories</h3>
                        <p className="text-footer-blue font-helvetica font-med font-12pt">See real results from our customers</p>
                    </div>
                    <IonIcon className="arrow_icon" src={side_arrow_icon} slot="end"></IonIcon>
                </IonCardContent>                
            </IonCard>
        </IonCol>
        <IonCol size='3' >
            <IonCard className="h-100 grey-border-2pt">
                <IonCardContent>
                    <IonIcon src={report_icon} slot="start"/>                    
                    <div className="quick-actions__text ">
                        <h3 className="text-map-main font-helvetica font-bold font-13pt">Run a Report</h3>
                        <p className="text-footer-blue font-helvetica font-med font-12pt">Benchmark, savings, amd performance reports</p>
                    </div>
                    <IonIcon className="arrow_icon" src={side_arrow_icon} slot="end"></IonIcon>
                </IonCardContent>                
            </IonCard>
        </IonCol>
    </IonRow>
};

export default ActionsRow;